import React, { useEffect, useState } from "react";
import { Breadcrumb, Card, Col, Container, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import useSEO from "../hooks/useSEO";
import { MyApi } from "../MyApi";
import EnquiryForm from "./EnquiryForm";

export default function ContactPage() {

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [gallery, setGallery] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openModal = (index) => {
    setActiveIndex(index);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + MyApi.CONTACT_PAGE,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data.status && res.data.data) {
          setData(res.data.data);
          setGallery(res.data.gallery || []);
        } else {
          setError(true);
        }
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, []);

  useSEO({
    title: data?.pagename || "Contact Us",
    description: data?.meta_description || "",
    canonical: window.location.href,
  });

  if (loading) return <p className="text-center py-5">Loading...</p>;
  if (error) return <h3 className="text-center py-5">404 - Page Not Found</h3>;

  return (
    <div>
      <div className="BreadcrumbStyle">
        <Container>
          <h1>{data?.pagename}</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{data?.pagename}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>

      <Container className="py-5">
        <Row>
          <Col md={8}><EnquiryForm /></Col>
          <Col md={4}>
          <Card className="shadow border-0">
            <Card.Body>
              <div dangerouslySetInnerHTML={{ __html: data?.pagecontent }} />
            </Card.Body>
          </Card>
          
          </Col>
        </Row>

        
        {/* CMS Content */}
      
        {/* Gallery */}
        {gallery.length > 0 && (
          <div className="mt-5">
            <h3 className="mb-4">{data?.pagename} Gallery</h3>

            <div className="row g-3">
              {gallery.map((img, index) => (
                <div className="col-6 col-md-4 col-lg-3" key={index}>
                  <div
                    className="gallery-item rounded-4 overflow-hidden"
                    role="button"
                    onClick={() => openModal(index)}
                  >
                    <img
                      src={img.image_url}
                      alt={img.gallerytitle}
                      className="img-fluid w-100"
                    />
                  </div>
                  <p className="text-center mt-1">{img.gallerytitle}</p>
                </div>
              ))}
            </div>
          </div>
        )}

      </Container>

      {/* Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Body className="p-0 text-center">
          <img
            src={gallery[activeIndex]?.image_url}
            alt="Preview"
            className="img-fluid"
            style={{
              maxHeight: "90vh",
              objectFit: "contain",
            }}
          />
        </Modal.Body>
      </Modal>
       <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3113.1105198601945!2d82.986582!3d25.333181!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398e2d7c2b44d3f7%3A0xc9a96556de51f0eb!2sTaxi%20Services%20Varanasi!5e1!3m2!1sen!2sin!4v1774585281904!5m2!1sen!2sin"
        
        height="450"
        style={{ border: 0, width:"100%" }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Varanasi Map"
      ></iframe>
    </div>
  );
}